import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adminapp-critical-error-api-failure',
  templateUrl: './critical-error-api-failure.component.html',
  styleUrls: ['./critical-error-api-failure.component.scss']
})
export class CriticalErrorApiFailureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
